import { render } from "./card.vue?vue&type=template&id=a2b0c4d6&scoped=true"
import script from "./card.vue?vue&type=script&lang=js"
export * from "./card.vue?vue&type=script&lang=js"

import "./card.vue?vue&type=style&index=0&id=a2b0c4d6&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-a2b0c4d6"

export default script